import {
	ScreenOrientation,
	type OrientationLockType,
} from '@capacitor/screen-orientation';

import { isApp, isIpad } from 'pkg/platform';

export async function lockOrientation(
	orientation: OrientationLockType = 'portrait'
): Promise<void> {
	const iPadDevice: boolean = await isIpad();

	if (!isApp() || iPadDevice) return;

	await ScreenOrientation.lock({ orientation });
}

export async function unlockOrientation(): Promise<void> {
	const iPadDevice: boolean = await isIpad();

	if (!isApp() || iPadDevice) return;

	await ScreenOrientation.unlock();
}
